var urlStr = window.location.host.match(/\.(\S*)/)[1].split(":")[0];

//获取cookie、
export function getCookie(name) {

    if(name !="appKey") {
      name = localStorage.getItem('environment')+'_'+name
    }
    let arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
    if (arr=document.cookie.match(reg)) {
        try{
            return JSON.parse(unescape(arr[2]))
        }catch (e) {
            return  arr[2]
        }

    } else {
      return null;
    }
    // return "";
}
//删除cookie
export function delCookie (name) {
    if(IsIPMode()) {
        urlStr = window.location.hostname
    }
    let exp = new Date();
    exp.setTime(exp.getTime() - 1);
    let cval = getCookie(name);
    name = localStorage.getItem('environment')+'_'+name
    if (cval != null) {
        document.cookie = name + "=" + cval + ";expires=" + new Date(0).toGMTString()+';domain='+urlStr
    }
}
//设置cookie,增加到vue实例方便全局调用
export function setCookie (c_name, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    setPathCookie(c_name,value,expiredays?exdate.toGMTString():'')
}


//设置２个月的过期时间
export function  setPersistenceCookie(key,value) {

  var exdate = new Date();
  exdate.setMonth(exdate.getMonth() + 2);
  setPathCookie(key,value,exdate.toGMTString())
}


function setPathCookie(key,value,exdate) {
  if(IsIPMode()) {
    urlStr = window.location.hostname
  }

  //path == 1 说明是正式环境,否则就是测试环境　在key值前加yufa_
  key = localStorage.getItem('environment')+'_'+key
  if(typeof value == "string") {
    document.cookie = key + '=' + value +((exdate == null) ? '' :';expires=' + exdate)+';domain='+urlStr
  }else{
    document.cookie = key + "=" + escape(JSON.stringify(value)) + ((exdate == null) ? "" :";expires=" + exdate)+';domain='+urlStr
  }

}


export function  setUserExpriationTip(sessionEffectivelyTime) {
  let cylceTime = new Date()
  let userLocalCycleTime = 3600
  if(sessionEffectivelyTime) {
    userLocalCycleTime = sessionEffectivelyTime*60
  }
  setPersistenceCookie('userLocalCycleTime',userLocalCycleTime)
  setCookie('userLocalExpiration', parseInt(cylceTime.getTime()/1000) + userLocalCycleTime)

}


//清空cookie
export function clearCookie(cookieNames = []) {
  if(IsIPMode()) {
    urlStr = window.location.hostname
  }


  let delCookie = function(key){
    document.cookie = key + '=0;path=/;expires=' + new Date(0).toUTCString();//清除当前域名下的,例如：m.kevis.com
    document.cookie = key + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString();//清除当前域名下的，例如 .m.kevis.com
    document.cookie = key + '=0;path=/;domain=' + urlStr + ';expires=' + new Date(0).toUTCString();//清除当前域名下的，例如 .m.kevis.com
    document.cookie = key + '=0;path=/;domain=*.com;expires=' + new Date(0).toUTCString();//清除一级域名下的或指定的，例如 .kevis.com
  }

  let  keys = document.cookie.match(/[^ =;]+(?=\=)/g);

  if (keys) {
      let cookieslen = cookieNames.length
      if(cookieslen < 1){
        for (var i = keys.length-1; i >= 0;i--) {
            delCookie(keys[i])
        }
      }else{
        for (var i = cookieslen-1; i>=0; i--) {
          let key = cookieNames[i]
            key = localStorage.getItem('environment')+'_'+key
          if(keys.includes(key)){
            delCookie(key)
          }

        }
    }

      // document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString();//清除当前域名下的,例如：m.kevis.com
      // document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString();//清除当前域名下的，例如 .m.kevis.com
      // document.cookie = keys[i] + '=0;path=/;domain=*.com;expires=' + new Date(0).toUTCString();//清除一级域名下的或指定的，例如 .kevis.com

  }
  console.log('已清除cookie');
}

export function getStrAppkey(str) {

  let appKey = str
  if (str.indexOf("?") != -1) {    //判断是否有参数
    appKey = appKey.split("?")[0]
  }else if(appKey.indexOf("&") != -1){
    appKey = appKey.split("&")[0]
  }
  return appKey
}

export function IsIPMode() {

   return "ip"== localStorage.getItem("urlMode")
}
